import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  text-align: center;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const IconContainer = styled.div`
  margin-bottom: 24px;
  opacity: 0.6;
`;

export const Mensagem = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c374151};
  margin: 0 0 16px 0;
`;

export const Descricao = styled.p`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.c6b7280};
  line-height: 1.5;
  max-width: 400px;
  margin: 0;
`;
